export class BankVerificationRequest{
    quoteStateId: string;
    sortCode: string;
    accountNumber: string;
    creditorName: string;
}